<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p class="display-2 text-center font-weight-bold indigo--text">4 Yellow Windows</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" class="pa-2" align="center">
        <v-img style="width:80%" src="@/assets/VA/PDS/Kale_Esposito/image1.jpg"></v-img>
        <v-container style="width:80%">
          <p class="text-sm-left">
            <i>4 yellow Windows</i> deals with both the conscious and subconscious mind. I created this piece at a time where I was exploring the idea of togetherness and independence in terms of seeking validation.
          </p>
          <p
            class="text-sm-left"
          >I wanted to create a piece of work that allowed the viewer to go within themselves and connect to their innermost thoughts, while simultaneously taking a step outside of their own minds-- as if they were looking in through four gleaming yellow windows. My intention was to produce a piece of work that highlighted my own relationship with the mind, body and soul as well as touching upon collective consciousness.</p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>